//SelfApplause.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
// import MainLayout from '../../layouts/MainLayout';

const SelfApplause = () => {
  const location = useLocation();
  const authState = useSelector(state => state.authReducer);
  const [applauses, setApplauses] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [name, setName] = useState('');
  const [place, setPlace] = useState('');
  const [tags, setTags] = useState('');
  const [applauseTo, setPurpose] = useState('');
  const [purposeHead, setPurposeHead] = useState('');
  const [selectedApplauseId, setSelectedApplauseId] = useState(null);
  const [iApplauded, setIApplauded] = useState(false);
  const [selfApplause, setSelfApplause] = useState(false);
  const [applauseForMe, setApplauseForMe] = useState(false);
  const [applauseRoute, setApplauseRoute] = useState("i-applauded");

  useEffect(() => {
    const myRoute = (location?.pathname || '').split('/').pop() || '';
    setApplauseRoute(myRoute);
  }, [location.pathname, setApplauseRoute]);

  const fetchApplauses = useCallback(async () => {
    
    const config = {
      url: "/applause/self",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id, nameCode: authState.user.think5whyscode}
    };

    // console.log("Self ApplauseSearch Payload: ", applauseRoute, config);

    try {
      const data = await fetchData(config, { showSuccessToast: false });
      setApplauses(data.applauses);
    } catch (error) {
      console.error('Error fetching applauses:', error);
    }
  }, [applauseRoute, authState.token, authState.user._id, authState.user.thin5whyscode, authState.isLoggedIn, fetchData, setApplauses]);

  useEffect(() => {
    fetchApplauses();
  }, [fetchApplauses]);


  const handleDelete = (id) => {
    const config = {
      url: `/applause/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchApplauses());
  }

  const handleView = (applauseId) => {
    setSelectedApplauseId(prevId => (prevId === applauseId ? null : applauseId));
  };

  const handleCloseApplauseDetails = () => {
    setSelectedApplauseId(null);
  };

  const handleApplauseClick = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplauseShare = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplauseSave = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const handleApplausePrint = (ApplauseId) => {
    setSelectedApplauseId(ApplauseId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  const sortedApplauses = [...applauses].sort((a, b) => new Date(b.applauseDate) - new Date(a.applauseDate));

  return (
      <div className='bg-black'>
        <div className='border-b border-blue-400'>
          <h3 className='text-lg lg:text-xl text-yellow-200 mt-1 py-2'>👏👏 I Applauded Myself </h3>
        </div>
        <div className="min-h-[80vh] p-2 mt-2">
            <div className="mt-1">
              {applauses && applauses.length !== 0 && (
                <div className="flex justify-between items-center border-b border-b-gray-300 mb-1">
                  <div className='mb-2'>
                    <h3 className='text-m lg:text-m mt-1 mx-2 text-white'>{applauses.length} Self Applause Found!</h3>
                  </div>
                  <div className='mr-2'>
                    <Link to='/applause/add' className='block w-full text-sm lg:texm-m h-8 px-1 py-2 ml-4 bg-blue-500 rounded-md'>
                      <FontAwesomeIcon className="bg-blue-500 mr-4 text-sm lg:texm-m" icon={faPlus} />  Add New
                    </Link>
                </div>
              </div>
              )}
            </div>
          {loading ? (
            <Loader />
          ) : (
            <div className='mt-1'>
              {applauses && applauses.length === 0 ? (
                <div className='h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                  <div className="flex justify-between items-center">
                    <div>
                     <h3 className='text-xl mt-1 mx-2 text-orange-400'>No Self Applause Record Found!</h3>
                    </div>
                    <div>
                      <Link to='/applause/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                      </Link>
                    </div>
                  </div>
                </div>
              ) : (
                sortedApplauses.map((applause, index) => (
                  <div key={applause._id} className="bg-black my-4 p-4 text-white border botder-gray-50 rounded-lg shadow-lg">
                    <div className='flex'>
                      <span className='font-medium'>#{index + 1} {'For '}{applause.title}{' On '}{formatDateTime(applause.applauseDate)}</span>
                      <Tooltip text={"View details"} position={"top"}>
                        <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(applause._id)}>
                          <i className="fa-solid fa-eye"></i>
                        </span>
                      </Tooltip>
                    </div>
                    {/* <div className='whitespace-pre  text-blue-700'>{applause.title}</div> */}
                    {selectedApplauseId === applause._id && (
                      <div className='bg-black text-white border border-gray-500 p-2'>
                        <p><strong>Headline:</strong> {applause.title}</p>
                        <p><strong>Message:</strong> {applause.description}</p>
                        <p><strong>Date:</strong> {formatDateTime(applause.applauseDate)}</p>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
        <footer className="bg-gray-900 border-t border-blue-400 text-gray-400 py-4">
          <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
            <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/about-us" className="hover:text-teal-300">About</Link>
              <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
              <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
              <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
            </div>
          </div>
        </footer>          
      </div>
  )
}

export default SelfApplause;
